'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _time = require('./time.view');

var _time2 = _interopRequireDefault(_time);

var _video = require('../../../constants/events/video');

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UPDATE_INTERVAL_DELAY = 500;

var TimeControl = function () {
  function TimeControl(_ref) {
    var eventEmitter = _ref.eventEmitter,
        engine = _ref.engine;

    _classCallCheck(this, TimeControl);

    this._eventEmitter = eventEmitter;
    this._engine = engine;

    this._bindCallbacks();
    this._initUI();
    this._bindEvents();

    this.setCurrentTime(0);
    this.setDurationTime(0);
  }

  _createClass(TimeControl, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._updateCurrentTime = this._updateCurrentTime.bind(this);
      this._updateDurationTime = this._updateDurationTime.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._toggleIntervalUpdates, this);
      this._eventEmitter.on(_video2.default.DURATION_UPDATED, this._updateDurationTime, this);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      this.view = new this.constructor.View();
    }
  }, {
    key: '_startIntervalUpdates',
    value: function _startIntervalUpdates() {
      if (this._updateControlInterval) {
        this._stopIntervalUpdates();
      }
      this._updateControlInterval = setInterval(this._updateCurrentTime, UPDATE_INTERVAL_DELAY);
    }
  }, {
    key: '_stopIntervalUpdates',
    value: function _stopIntervalUpdates() {
      clearInterval(this._updateControlInterval);
      this._updateControlInterval = null;
    }
  }, {
    key: '_toggleIntervalUpdates',
    value: function _toggleIntervalUpdates(_ref2) {
      var nextState = _ref2.nextState;
      var STATES = this._engine.STATES;


      switch (nextState) {
        case STATES.SRC_SET:
          this.reset();
          break;
        case STATES.PLAYING:
          this._startIntervalUpdates();
          break;
        case STATES.SEEK_STARTED:
          this._updateCurrentTime();
          break;
        default:
          this._stopIntervalUpdates();
          break;
      }
    }
  }, {
    key: '_updateDurationTime',
    value: function _updateDurationTime() {
      this.setDurationTime(this._engine.getDurationTime());
    }
  }, {
    key: '_updateCurrentTime',
    value: function _updateCurrentTime() {
      this.setCurrentTime(this._engine.getCurrentTime());
    }
  }, {
    key: 'setDurationTime',
    value: function setDurationTime(time) {
      this.view.setState({ duration: time });
    }
  }, {
    key: 'setCurrentTime',
    value: function setCurrentTime(time) {
      this.view.setState({ current: time });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setDurationTime(0);
      this.setCurrentTime(0);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._toggleIntervalUpdates, this);
      this._eventEmitter.off(_video2.default.DURATION_UPDATED, this._updateDurationTime, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._stopIntervalUpdates();
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;

      this.isHidden = null;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return TimeControl;
}();

TimeControl.View = _time2.default;
exports.default = TimeControl;
//# sourceMappingURL=time.controler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/time/time.controler.js
// module id = 1229
// module chunks = 1 2 3